module.exports = __webpack_public_path__ + "img/swapnil_video_thumbnail.8456c317.jpg";